module.exports = __webpack_public_path__ + "img/align-bottom-01.d219398f.svg";